/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import { observable, action, configure, makeAutoObservable } from 'mobx';

import { Form } from '_common/components/Form/Form';
import P1_INFO from '_common/formSource/kyc/company/P1_INFO';
import P1_COMMON from '_common/formSource/kyc/person/P1_COMMON';
import P2_GUARDIAN from '_common/formSource/kyc/person/P2_GUARDIAN';
import P3_PHOTO from '_common/formSource/kyc/person/P3_PHOTO';
import kycService from '_common/service/kycService';
import { translate } from '_common/utils/language';
import UTIL from '_common/utils/util';

import { RenderType } from '../../okjp/constants/JpEnum';

configure({
  enforceActions: 'always',
});

/*
 * TODO:
 * 按照最新的STEP定义, 拟修改为
//  成年人 1 4 3 提交 steps
// 未成年人 1 4 2 3 提交
 * 成年人 1 -> 4 -> 3
 * 未成年人 1 -> 4 -> 2 -> 3
 */
export const STEP = {
  NONE: 0,
  COMMON: 1,
  GUARDIAN: 2,
  DOCUMENTS: 3,
  PURPOSE: 4,
  DONE: 5, // 虚构用于标识newStep的，实际上后端没有这个enum
};

// 普通客户的步骤运算util

export const stepForNormal = [
  STEP.NONE,
  STEP.COMMON,
  STEP.PURPOSE,
  STEP.DOCUMENTS,
  STEP.DONE,
];

export const calcNormalStep = (
  // todo 这俩函数的作用是？？
  currentStep, // 当前步骤
  operator, // 运算符
  counter // 运算数字
) => {
  // TODO: 非需要监护人的情况没有STEP.GUARDIAN这一步，需要谨慎处理+-运算符的场景
  // 成年人的情况实际上没有step=2的场景，改造后以step=purpose+0.5代替以覆盖通用判断的场景
  const currentIndex =
    currentStep === STEP.GUARDIAN
      ? // todo 这个4.5是啥？？
        4.5
      : stepForNormal.findIndex((T) => {
          return T === currentStep;
        });
  if (operator === '+' || operator === '-') {
    if (operator === '+' && currentIndex + counter > stepForNormal.length - 1) {
      return stepForNormal[stepForNormal.length - 1];
    }
    if (operator === '-' && currentIndex - counter < 0) {
      return stepForNormal[0];
    }
    return stepForNormal[
      operator === '+' ? currentIndex + counter : currentIndex - counter
    ];
  }
  const targetIndex =
    counter === STEP.GUARDIAN
      ? 4.5
      : stepForNormal.findIndex((T) => {
          return T === counter;
        });
  // console.log(222, currentStep, operator, counter, currentIndex, targetIndex);
  if (operator === '>') {
    return currentIndex > targetIndex;
  }
  if (operator === '>=') {
    return currentIndex >= targetIndex;
  }
  if (operator === '<') {
    return currentIndex < targetIndex;
  }
  if (operator === '<=') {
    return currentIndex <= targetIndex;
  }
};

// 需要监护人的客户的步骤运算util

export const stepForGuardian = [
  STEP.NONE,
  STEP.COMMON,
  STEP.PURPOSE,
  STEP.GUARDIAN,
  STEP.DOCUMENTS,
  STEP.DONE,
];

export const calcGuardianStep = (
  currentStep, // 当前步骤
  operator, // 运算符
  counter // 运算数字
) => {
  const currentIndex = stepForGuardian.findIndex((T) => {
    return T === currentStep;
  });
  if (operator === '+' || operator === '-') {
    if (
      operator === '+' &&
      currentIndex + counter > stepForGuardian.length - 1
    ) {
      return stepForGuardian[stepForGuardian.length - 1];
    }
    if (operator === '-' && currentIndex - counter < 0) {
      return stepForGuardian[0];
    }
    return stepForGuardian[
      operator === '+' ? currentIndex + counter : currentIndex - counter
    ];
  }
  const targetIndex = stepForGuardian.findIndex((T) => {
    return T === counter;
  });
  if (operator === '>') {
    return currentIndex > targetIndex;
  }
  if (operator === '>=') {
    return currentIndex >= targetIndex;
  }
  if (operator === '<') {
    return currentIndex < targetIndex;
  }
  if (operator === '<=') {
    return currentIndex <= targetIndex;
  }
};

export default class okcoinKycStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      renderType: observable,
      guardianInfo: observable,
      companyBaseInfo: observable,
      streetList: observable,
      streetList1: observable,
      streetList2: observable,
      streetList3: observable,
      careerLvOneList: observable,
      initData: observable,
      baseInfo: observable,
      ekycConfig: observable,
      rekycConfig: observable,
      isShowRekycNotification: observable,
      type: observable,
      step: observable,
      newStep: observable,
      status: observable,
      saveOne: observable,
      saveTwo: observable,
      saveThree: observable,
      saveGuardian: observable,
      needGuardian: observable,
      currSubmitStep: observable,
      tabIndex: observable,
      countryList: observable,
      firstRenderType: observable,
      isInsider: observable,
      selectedInsiderCoinIdList: observable,
      insiderCoinList: observable,
      insiderRelation: observable,
      clauseInfoList: observable,
      guardianClauseListOne: observable,
      guardianClauseListTwo: observable,
      hasGuardianOneInfo: observable,
      hasGuardianTwoInfo: observable,
      residenceIsJapan: observable,
      isSameLegalAsDirector: observable,
      firstRender: observable,
      getTemplate: action,
      getCompanyTemplate: action,
      getUserType: action,
      getInitInfo: action,
      getBaseInfo: action,
      getGuardian: action,
      getCountry: action,
      getPersonCareer: action,
      getCompanyCareer: action,
      getCompanyInfo: action,
      getInsiderCoinList: action,
      onSaveCallback: action,
      onNextStepCallback: action,
      setCountryList: action,
      setSaveOne: action,
      setSaveTwo: action,
      setSaveThree: action,
      setSaveGuarbian: action,
      setTabIndex: action,
      setNeedGuardian: action,
      setInitData: action,
      setEkycConfig: action,
      setRekycConfig: action,
      setIsShowRekycNotification: action,
      setIsSameLegalAsDirector: action,
      setNewStep: action,
      setStep: action,
      setGuardianInfo: action,
      setRenderType: action,
      setStreetList1: action,
      setStreetList2: action,
      setStreetList3: action,
      setBaseInfo: action,
      setFirstRenderType: action,
      setCurrSubmitStep: action,
      setStatus: action,
      setStreetList: action,
      setCareerLvOneList: action,
      setCompanyBaseInfo: action,
      setType: action,
      setFirstRender: action,
      setIsInsider: action,
      setSelectedInsiderCoinId: action,
      setSelectedInsiderCoinIdList: action,
      setInsiderRelation: action,
      setInsiderCoinList: action,
      clearInsiderInfo: action,
      setClause: action,
      setClauseInfo: action,
      setGuardianClauseInfo: action,
      setGuardianClause: action,
      changeHasGuardianOneInfo: action,
      changeHasGuardianTwoInfo: action,
      changeResidence: action,
    });

    this.loadingStore = rootStore.loadingStore;
  }

  renderType = 999; // 0：初始状态  1：渲染状态 2：显示状态
  guardianInfo = {};
  companyBaseInfo = {}; // 企业数据容器

  streetList = []; // 街道 数据源  本人基本信息用
  streetList1 = []; // 街道1 数据源  监护人1用
  streetList2 = []; // 街道2 数据源 监护人2 用
  streetList3 = []; // 法人街道 数据源 用

  careerLvOneList = [];

  initData = {};
  baseInfo = {};
  ekycConfig = {};
  rekycConfig = {};
  isShowRekycNotification = false;

  type = '';
  step = '';
  newStep = '';
  status = '';
  saveOne = '';
  saveTwo = '';
  saveThree = '';
  saveGuardian = '';
  needGuardian = '';
  currSubmitStep = '';

  tabIndex = {};

  countryList = []; // 国籍国家列表

  firstRenderType = 999;

  isInsider = 0; // 是否是内部者，0：否，1：是
  selectedInsiderCoinIdList = []; // 作为内部者的虚拟货币
  insiderCoinList = []; // insiderCoinList from DB
  insiderRelation = ''; // 内部者与所选择虚拟货币的关系
  clauseInfoList = []; // 个人基本信息里的协议

  guardianClauseListOne = []; // 监护人1基本信息里的协议
  guardianClauseListTwo = []; // 监护人2基本信息里的协议

  hasGuardianOneInfo = false; // 有监护人1基本信息
  hasGuardianTwoInfo = false; // 有监护人2基本信息

  residenceIsJapan = true;
  isSameLegalAsDirector = 0;

  // 增加首次加载监听(首次加载的时候需要处理跳转到最近未保存步骤的逻辑)
  firstRender = false;

  /**
   * 获取个人模板
   * @returns {Array|*|void}
   */
  getTemplate() {
    let template = [];
    switch (this.newStep) {
      case STEP.NONE || STEP.COMMON:
        template = UTIL.deepCopy(P1_COMMON());
        break;
      case 2: // STEP.GUARDIAN || STEP.DOCUMENTS TODO
        if (this.needGuardian) {
          template = UTIL.deepCopy(P2_GUARDIAN()); // 做一次深度拷贝
        } else {
          template = UTIL.deepCopy(P3_PHOTO());
        }
        break;
      case STEP.DOCUMENTS:
        template = UTIL.deepCopy(P3_PHOTO());
        break;
      case STEP.PURPOSE:
        break;
      default:
        break;
    }
    template = Form.conversion(template); // 转换为formLine 使用的数据模板
    return template;
  }

  /**
   * 获取企业模板
   * @returns {Array|*|void}
   */
  getCompanyTemplate() {
    let template = [];
    const haveFilledPurpose = 2;
    switch (this.newStep) {
      case STEP.NONE || STEP.COMMON:
        template = UTIL.deepCopy(P1_INFO());
        break;
      case haveFilledPurpose: // STEP.GUARDIAN || STEP.DOCUMENTS 历史遗留问题 step是判断已完成的步骤，即使是在成年人的场景下也还是会有step=2的情况，需要特别注意调转顺序后已经填写取引目的的情况
        if (this.needGuardian) {
          template = UTIL.deepCopy(P2_GUARDIAN()); // 做一次深度拷贝
        } else {
          template = UTIL.deepCopy(P3_PHOTO());
        }
        break;
      case STEP.DOCUMENTS:
        template = UTIL.deepCopy(P3_PHOTO());
        break;
      case STEP.PURPOSE:
        break;
      default:
        break;
    }
    template = Form.conversion(template); // 转换为formLine 使用的数据模板
    return template;
  }

  isAllStepDone = (_step, _needGuardian) => {
    if (_needGuardian) {
      return calcGuardianStep(_step, '>=', STEP.GUARDIAN);
    }
    return calcNormalStep(_step, '>=', STEP.DOCUMENTS); // TODO
  };

  /**
   * 个人用户/法人用户逻辑分开后，需要调取多一次init-info来获取类型
   */
  async getUserType(next) {
    this.loadingStore.showLoading();
    const res = await kycService.getInitInfoV2();
    const infoData = res.data || {};
    const { type } = infoData;
    this.setType(type);
    if (typeof next === 'function') {
      await next(infoData);
    }
  }

  /**
   * 获取初始化信息
   */
  async getInitInfo(infoData, next) {
    if (infoData === undefined) {
      this.loadingStore.showLoading();
      await this.getInsiderCoinList();
      const res = await kycService.getInitInfoV2();
      this.loadingStore.hideLoading();
      infoData = res.data || {};
    } else {
      // getUserType的后续逻辑
      await this.getInsiderCoinList();
      this.loadingStore.hideLoading();
    }

    const { type } = infoData;

    if (Number(type) === 0 && infoData.isFilledPersonalInfo) {
      // 获取ekyc配置，如果啥东西都没有填过，就要等到保存本人情报再获取
      const resEkycConfig = await kycService.getEkycConfig();
      this.setEkycConfig(resEkycConfig.data);
    }

    let saveOne = false;
    let saveGuardian = false;
    let saveTwo = false;
    let saveThree = false;

    let { step } = infoData;
    const {
      isFilledPersonalInfo,
      isFilledPurpose,
      isFilledGuardianInfo,
      isUploadFileInfo,
      needGuardian,
      isSameLegalAsDirector,
    } = infoData;

    // 再kyc状态，需要获取类型
    const resRekycInfo = await kycService.getRekycInfo();
    const rekycInfo = resRekycInfo.data || {};
    this.setRekycConfig(rekycInfo);

    if (needGuardian) {
      if (isUploadFileInfo) {
        step = STEP.DOCUMENTS;
      } else if (isFilledGuardianInfo) {
        step = STEP.GUARDIAN;
      } else if (isFilledPurpose) {
        step = STEP.PURPOSE;
      } else if (isFilledPersonalInfo) {
        step = STEP.COMMON;
      } else {
        step = STEP.NONE;
      }
    } else if (isUploadFileInfo) {
      step = STEP.DOCUMENTS;
    } else if (isFilledPurpose) {
      step = STEP.PURPOSE;
    } else if (isFilledPersonalInfo) {
      step = STEP.COMMON;
    } else {
      step = STEP.NONE;
    }
    const originalStep = step;
    // 当 状态为 8，也是拒绝，保持和 3一致
    let kycStatus = infoData.status;
    if (kycStatus === 8) {
      kycStatus = 3;
    }
    // 修正：因为老的逻辑原因，非监护人上传好证件之后step会变成2，不符合预期，手动修正为3
    if (needGuardian === 0 && step === STEP.GUARDIAN) {
      step = STEP.DOCUMENTS;
    }
    this.setType(type);

    // if (step >= 1) {
    if (
      needGuardian
        ? calcGuardianStep(originalStep, '>=', STEP.COMMON)
        : calcNormalStep(originalStep, '>=', STEP.COMMON)
    ) {
      saveOne = true;
    }
    if (needGuardian === 0) {
      // 无需监护人
      // if (step >= 2) {
      if (calcNormalStep(originalStep, '>=', STEP.PURPOSE)) {
        saveTwo = true;
      }
      // if (step >= 3) {
      if (calcNormalStep(originalStep, '>=', STEP.DOCUMENTS)) {
        saveThree = true;
      }
    } else if (needGuardian === 1) {
      // 需要监护人
      // if (step >= 2) {
      if (calcGuardianStep(originalStep, '>=', STEP.GUARDIAN)) {
        saveGuardian = true;
      }
      // if (step >= 3) {
      if (calcGuardianStep(originalStep, '>=', STEP.PURPOSE)) {
        saveTwo = true;
      }
      // if (step >= 4) {
      if (calcGuardianStep(originalStep, '>=', STEP.DOCUMENTS)) {
        saveThree = true;
      }
    }

    // TODO: 首次加载的时候需要处理跳转到最近未保存步骤的逻辑(有待完善)
    // kyc处于被打回的状态不需要跳转
    if (this.firstRender === false) {
      if (kycStatus !== 0 && kycStatus !== undefined) {
        this.setFirstRender(true);
      } else if (needGuardian === 0) {
        // 无需监护人
        if (
          (step === STEP.COMMON && saveOne) ||
          (step === STEP.PURPOSE && saveTwo) ||
          (step === STEP.DOCUMENTS && saveThree)
        ) {
          // 权宜之计，待下一步修改
          step = calcNormalStep(step, '+', 1);
        }
      } else if (
        (step === STEP.COMMON && saveOne) ||
        (step === STEP.GUARDIAN && saveGuardian) ||
        (step === STEP.PURPOSE && saveTwo) ||
        (step === STEP.DOCUMENTS && saveThree)
      ) {
        // 权宜之计，待下一步修改
        step = calcGuardianStep(step, '+', 1);
      }
    }

    // 判断是否需要监护人
    const tabIndex = {};
    if (needGuardian === 1) {
      tabIndex.trade = 2;
      tabIndex.guardian = 3;
      tabIndex.card = 4;
      tabIndex.submit = 5;
    } else {
      tabIndex.trade = 2;
      tabIndex.card = 3;
      tabIndex.submit = 4;
    }
    this.setStatus(kycStatus);
    this.setSaveOne(saveOne);
    this.setSaveTwo(saveTwo);
    this.setSaveThree(saveThree);
    this.setSaveGuarbian(saveGuardian);
    this.setTabIndex(tabIndex);
    this.setNeedGuardian(needGuardian === 1);
    this.setInitData(infoData);
    this.setIsSameLegalAsDirector(isSameLegalAsDirector);
    this.setStep(step || STEP.NONE);
    // 根据接口返回结果判断是否需要强制跳转到最后一步
    let skipCurrSubmitStepLogic = false;
    // 0 : users not submit, 3:submit has been reject
    if (kycStatus == 0 || kycStatus === 3) {
      if (kycStatus === 3) {
        // 查询是否需要再kyc
        const resCheckEkycStatus = await kycService.checkEkycStatus();
        if (resCheckEkycStatus?.data === 1) {
          // 不需要 直接跳转到最后一步
          step = STEP.DONE;
          this.setStep(step);
          this.setNewStep(step);
          skipCurrSubmitStepLogic = true;
        } else if (isUploadFileInfo === false) {
          // 覆盖被驳回后从kyc转ekyc且ekyc失败后，还在容忍次数范围内时，isUploadFileInfo被置为false的情形
          this.setNewStep(STEP.DOCUMENTS);
        } else if (window.location.href.includes('fromEKyc=1')) {
          // 有特殊字段也强制跳转
          this.setStep(step);
          this.setNewStep(step);
          skipCurrSubmitStepLogic = true;
        }
      } else {
        this.setNewStep(step || STEP.COMMON);
      }
    } else {
      // KYC提出不可のため、active tabを一つもどす。
      // this.setNewStep(step - 1);
      this.setNewStep(
        needGuardian
          ? calcGuardianStep(step, '-', 1)
          : calcNormalStep(step, '-', 1)
      );
    }

    // 跳过判定 直接跳转到最后一步
    if (skipCurrSubmitStepLogic !== true) {
      // 保存直後は該当stepを表示する
      // if (this.currSubmitStep != '' && this.currSubmitStep < step) {
      //   this.setNewStep(this.currSubmitStep);
      // }
      const resCompareStep = needGuardian
        ? calcGuardianStep(this.currSubmitStep, '<', step)
        : calcNormalStep(this.currSubmitStep, '<', step);
      if (this.currSubmitStep != '' && resCompareStep) {
        this.setNewStep(this.currSubmitStep);
      }

      // 保存直後は該当stepを優先(跳过首次加载的情况)
      if (
        this.currSubmitStep == '' &&
        this.isAllStepDone(step, this.needGuardian) &&
        this.firstRender !== false
      ) {
        // 提出可能な状態であればstep1をdefault表示, step3の取引目的を修正することはあまりないため。
        this.setNewStep(1);
      }
    }

    this.setFirstRender(true);

    if (type === 0) {
      // 根据step判断要获取哪页的数据
      switch (this.newStep) {
        case STEP.COMMON:
          this.getBaseInfo();
          break;
        case STEP.GUARDIAN:
          if (this.needGuardian) {
            this.getGuardian();
          }
          break;
        default:
          // this.getBaseInfo();
          break;
      }
    } else if (type === 1) {
      // 根据step判断要获取哪页的数据
      switch (this.newStep) {
        case STEP.COMMON:
          this.getCompanyInfo();
          break;
        default:
          break;
      }
    }

    if (typeof next === 'function') {
      if (rekycInfo.oddType === 2 && rekycInfo.infoUpdated === 0) {
        next(STEP.DOCUMENTS);
      } else {
        next(STEP.COMMON);
      }
    }
  }

  /**
   * 获取基本信息
   * @returns {Promise<void>}
   */
  async getBaseInfo(forceJump) {
    this.setRenderType(999); // 重置 renderType

    if (this.step === STEP.NONE) {
      this.setRenderType(0);
      return;
    }

    this.loadingStore.showLoading();
    const res = await kycService.getBaseInfoPersonal(
      this.initData.businessType
    );
    this.loadingStore.hideLoading();
    if (res.code === 0 && res.data) {
      this.setRenderType(RenderType.SHOW);
      // 针对在留信息做调整
      if (res.data.residenceType === 0 && res.data.residenceValidity === '') {
        // 既存数据修复
        res.data.residenceType = null;
      }
      if (res.data.countryCode === '4567') {
        res.data.residenceType = null;
      }
      const baseInfo = res.data;

      // TODO 是否是内部者和协议，假数据填充，接口添加字段后改为真正的字段
      const { isInsider, insiderCoin, insiderCoinRelation, agreeProtocol } =
        baseInfo;
      const selectedInsiderCoinIdList = insiderCoin.split(',');
      const clauseInfoList = agreeProtocol.split(',');
      this.setIsInsider(isInsider);
      this.setSelectedInsiderCoinIdList(selectedInsiderCoinIdList);
      this.setInsiderRelation(insiderCoinRelation);
      this.setClauseInfo(clauseInfoList);

      const { postCode, career } = baseInfo;
      // 解析职业数据
      const careers = career && career.split(',');
      if (careers && careers.length > 0) {
        baseInfo.careerLvOne = careers[0];

        this.getPersonCareer();
      }
      this.setBaseInfo(baseInfo);
      // 根据postCode 获取
      const addressRes = await kycService.getAddressByPostCode({ postCode });
      const streetList = [];
      addressRes.data.forEach((addressItem) => {
        streetList.push({
          value: addressItem.street,
          label: addressItem.street,
        });
      });
      this.setStreetList(streetList);
      // 在留资格导致的再KYC/ODD体系导致的再KYC选择了変更あり这两者之后的弹窗，点击确认需要直接进入编辑状态
      if (
        forceJump &&
        (this.rekycConfig?.reKycType === 0 ||
          this.rekycConfig?.infoUpdated === 1)
      ) {
        this.setRenderType(RenderType.INPUT);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    } else {
      this.setRenderType(RenderType.INPUT);
    }
  }

  /**
   * 获取监护人信息
   */
  async getGuardian() {
    this.setRenderType(999); // 重置 renderType
    this.loadingStore.showLoading();
    const res = await kycService.getGuardianInfo(1);
    this.loadingStore.hideLoading();
    if (res.code === 0 && res.data && res.data.length > 0) {
      const guardianInfo = res.data;
      if (guardianInfo.length === 1) {
        this.changeHasGuardianOneInfo(true);
        this.changeHasGuardianTwoInfo(false);
      } else if (guardianInfo.length > 1) {
        this.changeHasGuardianOneInfo(true);
        this.changeHasGuardianTwoInfo(true);
      }
      // TODO 监护人协议条款，假数据填充，接口添加字段后改为真正的字段
      guardianInfo.forEach(async (item, index) => {
        const clauseInfo = item.agreeProtocol;
        const clauseInfoList = clauseInfo.split(',');
        this.setGuardianClauseInfo(index, clauseInfoList);
      });

      // 解析下职业
      const guardianInfoTemp = [];
      guardianInfo.forEach(async (item) => {
        const { career } = item;
        const careers = career && career.split(',');
        const itemTemp = UTIL.deepCopy(item);
        if (careers && careers.length > 0) {
          itemTemp.careerLvOne = careers[0];
        }
        guardianInfoTemp.push(itemTemp);
      });
      // 改造监护人返回数据格式
      const guardianInfoJson = {};
      guardianInfoTemp.forEach((item, index) => {
        Object.entries(item).forEach((itemTemp) => {
          const key = `${itemTemp[0]}${index}`;
          guardianInfoJson[key] = itemTemp[1];
        });
      });

      this.setGuardianInfo(guardianInfoJson);
      // 防止用户有监护人的时候，修改年龄为无监护人，再修改为有监护人
      if (this.step === 1) {
        this.setRenderType(RenderType.INPUT);
      } else {
        this.setRenderType(RenderType.SHOW);
      }

      // 拉取职业数据
      guardianInfo.forEach(async (item, index) => {
        const { career } = item;
        const careers = career && career.split(',');
        const itemTemp = UTIL.deepCopy(item);
        if (careers && careers.length > 0) {
          itemTemp.careerLvOne = careers[0];
        }

        const { postCode } = item;
        const addressRes = await kycService.getAddressByPostCode({ postCode });
        const streetList = [];
        addressRes.data.forEach((addressItem) => {
          streetList.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });

        if (index === 0) {
          this.setStreetList1(streetList);
        } else if (index === 1) {
          this.setStreetList2(streetList);
        }
      });
    } else {
      this.setRenderType(RenderType.INPUT);
    }
  }

  /**
   * 获取国家信息
   * @returns {Promise<void>}
   */
  async getCountry() {
    const res = await kycService.getKycCountryNew();
    const countryList = [];
    const primeCountryList = [];
    let JapanData = null;
    let ChinaData = null;
    res &&
      res.data &&
      res.data.forEach((item) => {
        const label = `${translate(item.id)} ${
          item.status === 1
            ? ''
            : ` (${translate('user.page.countryNoSupport')})`
        }`;

        if (item.id == 4567) {
          JapanData = {
            value: item.id,
            label,
            disabled: !item.status,
          };
        } else if (item.id == 4518) {
          ChinaData = {
            value: item.id,
            label,
            disabled: !item.status,
          };
        } else {
          countryList.push({
            value: item.id,
            label,
            disabled: !item.status,
          });
        }
      });
    primeCountryList.push(JapanData);
    primeCountryList.push(ChinaData);
    this.setCountryList(primeCountryList.concat(countryList));
  }

  /**
   * 获取职业信息
   * @returns {Promise<void>}
   */
  async getPersonCareer() {
    const res = await kycService.getPersonCareer();
    const careerList = [];
    res &&
      res.data &&
      res.data.forEach((item) => {
        careerList.push({
          value: item.id,
          label: translate(item.id),
        });
      });
    this.setCareerLvOneList(careerList);
  }

  /**
   *
   * @returns {Promise<void>}
   */
  async getCompanyCareer() {
    const res = await kycService.getCompanyCareer();
    const careerList = [];
    res &&
      res.data &&
      res.data.forEach((item) => {
        careerList.push({
          value: item.id,
          label: translate(item.id),
        });
      });
    this.setCareerLvOneList(careerList);
  }

  /**
   * 获取企业基本信息
   * @returns {Promise<void>}
   */
  async getCompanyInfo() {
    this.setRenderType(999);
    this.loadingStore.showLoading();
    const res = await kycService.getBaseInfoCorp(this.initData.businessType);
    this.loadingStore.hideLoading();
    if (
      res &&
      res.code === 0 &&
      res.data &&
      Object.entries(res.data).length > 0
    ) {
      // 解析企业基本信息 / Analyze basic business information
      const companyBaseInfo = res.data;
      const {
        careerType,
        companyLegal,
        companyDirector,
        shareholders,
        tenureReason,
        postCode,
        isInsider,
        insiderCoin,
        insiderCoinRelation,
      } = companyBaseInfo;

      const selectedInsiderCoinIdList = insiderCoin.split(',');
      this.setIsInsider(isInsider);
      this.setSelectedInsiderCoinIdList(selectedInsiderCoinIdList);
      this.setInsiderRelation(insiderCoinRelation);

      // 处理居住地 / Handling residence
      // companyLegal.residence = `${companyLegal.residence}`;

      const directorPostCode = companyDirector.postCode;
      const legalPostCode = companyLegal.postCode;
      if (shareholders && shareholders.length > 0) {
        const shareholdersListValue = shareholders.map((item) => {
          return UTIL.deepCopy(item);
        });
        companyBaseInfo.shareholdersListValue = shareholdersListValue;
      }
      delete companyBaseInfo.companyDirector;
      delete companyBaseInfo.companyLegal;
      delete companyBaseInfo.shareholders;

      // 处理企业业务类型 / Handling business type
      if (careerType) {
        companyBaseInfo.careerLvOne = careerType;
      }

      // 处理担当者 / Dealer
      if (companyDirector) {
        companyBaseInfo.firstName = companyDirector.firstName;
        companyBaseInfo.lastName = companyDirector.lastName;
        companyBaseInfo.firstNamePy = companyDirector.firstNamePy;
        companyBaseInfo.lastNamePy = companyDirector.lastNamePy;
        companyBaseInfo.firstNameEn = companyDirector.firstNameEn;
        companyBaseInfo.lastNameEn = companyDirector.lastNameEn;

        Object.entries(companyDirector).forEach((item) => {
          companyBaseInfo[`director${item[0]}`] = item[1];
        });
      }

      // 处理法人 / Handling legal person
      if (companyLegal) {
        Object.entries(companyLegal).forEach((item) => {
          companyBaseInfo[`legal${item[0]}`] = item[1];
        });
      }

      // 处理股东信息 / Handling shareholder information
      if (shareholders) {
        let messageText = '';
        let maxNum = 3;
        if (tenureReason && tenureReason === 1) {
          messageText = translate('jp.company.share25');
        } else if (tenureReason && tenureReason === 2) {
          messageText = translate('jp.company.share50');
          maxNum = 1;
        }
        const inputList = shareholders.map((item, index) => {
          const info = {
            id: item.id,
            cardTitle: `${translate('jp.company.share')}-${index + 1}`,
            inputAttr: {
              primaryText: `${item.lastName} ${item.firstName}`,
              messageList: [
                {
                  text: messageText,
                  type: 'company-share-message',
                },
              ],
            },
          };
          return info;
        });

        const currNum = inputList.length;
        for (let i = 0; i < maxNum - currNum; i++) {
          inputList.push({});
        }
        companyBaseInfo.shareholders = inputList;
      }

      this.setCompanyBaseInfo(companyBaseInfo);
      this.setRenderType(RenderType.SHOW);

      // 处理街道地址 / Handling street addresses
      const addressRes = await kycService.getAddressByPostCode({ postCode });
      const streetList1 = [];
      if (addressRes.data && addressRes.data.length > 0) {
        addressRes.data.forEach((addressItem) => {
          streetList1.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });
      }
      this.setStreetList1(streetList1);

      // 再处理担当者地址 / Reprocessing the address of the person in charge
      const derAddressRes = await kycService.getAddressByPostCode({
        postCode: directorPostCode,
      });
      const streetList2 = [];
      if (derAddressRes.data && derAddressRes.data.length > 0) {
        derAddressRes.data.forEach((addressItem) => {
          streetList2.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });
      }
      this.setStreetList2(streetList2);

      // 再处理法人地址 / Reprocessing the address of the person in charge
      const legalAddressRes = await kycService.getAddressByPostCode({
        postCode: legalPostCode,
      });
      const streetList3 = [];
      if (legalAddressRes.data && legalAddressRes.data.length > 0) {
        legalAddressRes.data.forEach((addressItem) => {
          streetList3.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });
      }
      this.setStreetList3(streetList3);
    } else {
      this.setRenderType(RenderType.INPUT);
    }
  }

  /**
   * Get InsiderCoinList from DB
   * @param
   */
  async getInsiderCoinList() {
    const res = await kycService.getInsiderCoinList();
    const filterJPYList = [];
    if (res.data && res.data.length > 0) {
      res.data = res.data.map((T) => {
        // 新旧接口字段不一样，为了避免大幅度修改，沿用旧字段
        const newT = T;
        const { isUnifiedAccount } = window.okGlobal;
        if (!isUnifiedAccount) {
          newT.id = T.baseCurrencyId;
          newT.symbol = T.baseCurrencySymbol;
        }
        return newT;
      });
      res.data.forEach((coin) => {
        if (coin.symbol !== 'JPY') {
          filterJPYList.push(coin);
        }
      });
    }
    this.setInsiderCoinList(filterJPYList);
  }

  /**
   * 每一级别保存响应
   * @param step
   */
  onSaveCallback(step) {
    this.setCurrSubmitStep(step); // 设置当前提交步数
    this.getInitInfo();
  }

  /**
   * 每一级别下一步响应
   * @param step
   */
  onNextStepCallback(nextStep) {
    if (this.needGuardian && nextStep === STEP.GUARDIAN) {
      this.getGuardian();
    }
    this.setCurrSubmitStep('');
    this.setNewStep(nextStep);
  }

  setCountryList(list) {
    this.countryList = list;
  }

  setSaveOne(flag) {
    this.saveOne = flag;
  }

  setSaveTwo(flag) {
    this.saveTwo = flag;
  }

  setSaveThree(flag) {
    this.saveThree = flag;
  }

  setSaveGuarbian(flag) {
    this.saveGuardian = flag;
  }

  setTabIndex(flag) {
    this.tabIndex = flag;
  }

  setNeedGuardian(flag) {
    this.needGuardian = flag;
  }

  setInitData(data) {
    this.initData = data;
  }

  setEkycConfig(data) {
    this.ekycConfig = data;
  }

  setRekycConfig(data) {
    this.rekycConfig = {
      ...data,
      ts: Date.now(),
    };
  }

  setIsShowRekycNotification(data) {
    this.isShowRekycNotification = data;
  }

  setIsSameLegalAsDirector(data) {
    this.isSameLegalAsDirector = data;
  }

  setNewStep(step) {
    this.newStep = step;
  }

  setStep(step) {
    this.step = step;
  }

  setGuardianInfo(info) {
    this.guardianInfo = info;
  }

  setRenderType(type) {
    this.renderType = type;
  }

  setStreetList1(list) {
    this.streetList1 = list;
  }

  setStreetList2(list) {
    this.streetList2 = list;
  }

  setStreetList3(list) {
    this.streetList3 = list;
  }

  setBaseInfo(info) {
    this.baseInfo = info;
  }

  setFirstRenderType(type) {
    this.firstRenderType = type;
  }

  setCurrSubmitStep(step) {
    this.currSubmitStep = step;
  }

  setStatus(status) {
    this.status = status;
  }

  setStreetList(streetList) {
    this.streetList = streetList;
  }

  setCareerLvOneList(careerLvOneList) {
    this.careerLvOneList = careerLvOneList;
  }

  setCompanyBaseInfo(companyBaseInfo) {
    this.companyBaseInfo = companyBaseInfo;
  }

  setType(type) {
    this.type = type;
  }

  setFirstRender(firstRender) {
    this.firstRender = firstRender;
  }

  // 初始化时设置是否是内部者
  setIsInsider = (isInsider) => {
    this.isInsider = isInsider;
  };

  // 点击多选选按钮时设置是否是内部者
  setSelectedInsiderCoinId = (insiderCheckBox) => {
    this.selectedInsiderCoinIdList = [];
    insiderCheckBox.forEach((item) => {
      if (item.check) {
        this.selectedInsiderCoinIdList.push(String(item.id));
      }
    });
  };

  // 设置内部者虚拟币列表信息
  setSelectedInsiderCoinIdList = (selectedInsiderCoinIdList) => {
    this.selectedInsiderCoinIdList = selectedInsiderCoinIdList;
  };

  // 设置内部者和虚拟币的关系
  setInsiderRelation = (insiderRelation) => {
    this.insiderRelation = insiderRelation;
  };

  // Set insiderCoinList
  setInsiderCoinList = (insiderCoinList) => {
    this.insiderCoinList = insiderCoinList;
  };

  // 不是内部者时，清空内部者虚拟币列表信息和虚拟币的关系
  clearInsiderInfo = () => {
    this.setSelectedInsiderCoinIdList([]);
    this.setInsiderRelation('');
  };

  // 操作多选框时设置本人条款信息
  setClause = (clauseInfo) => {
    this.clauseInfoList = [];
    clauseInfo.forEach((item) => {
      if (item.check) {
        this.clauseInfoList.push(item.id);
      }
    });
  };

  // 初始化时设置本人条款信息
  setClauseInfo = (clauseInfoList) => {
    this.clauseInfoList = clauseInfoList;
  };

  // 初始化时设置监护人条款信息
  setGuardianClauseInfo = (type, guardianClauseList) => {
    if (type === 0) {
      this.guardianClauseListOne = guardianClauseList;
    } else if (type === 1) {
      this.guardianClauseListTwo = guardianClauseList;
    }
  };

  // 操作多选框时设置监护人条款信息
  setGuardianClause = (type, guardianClauseList) => {
    if (type === 0) {
      this.guardianClauseListOne = [];
    } else if (type === 1) {
      this.guardianClauseListTwo = [];
    }
    guardianClauseList.forEach((item) => {
      if (item.check) {
        if (type === 0) {
          this.guardianClauseListOne.push(String(item.id));
        } else if (type === 1) {
          this.guardianClauseListTwo.push(String(item.id));
        }
      }
    });
  };

  // 切换监护人1是否有信息的状态
  changeHasGuardianOneInfo = (isHas) => {
    this.hasGuardianOneInfo = isHas;
  };

  // 切换监护人1是否有信息的状态
  changeHasGuardianTwoInfo = (isHas) => {
    this.hasGuardianTwoInfo = isHas;
  };

  changeResidence = (flag) => {
    this.residenceIsJapan = flag;
  };
}
